import { SETTINGS_CHANGED/*, AUTH_DISCONNECTED*/ } from '../mutation-types';
import each from 'lodash/each';
import get from 'lodash/get';

import { GA_KEY, MUX_API_KEY } from '../../config';

const DEFAULT_STATE = {
   gaid: GA_KEY,
   muxApiKey: MUX_API_KEY,
   redirectUrl: ''
};

const getters = {
   getMuxApiKey   : state => state.muxApiKey || MUX_API_KEY,
   getRedirectUrl : state => state.redirectUrl || ''
};

const actions = {
};

const mutations = {
   [SETTINGS_CHANGED](state, settings) {
      each(DEFAULT_STATE, ( val, key ) => {
         state[key] = get(settings, key, val);
      } );
   // },
   // [AUTH_DISCONNECTED](state) {
   //    each(DEFAULT_STATE, ( val, key ) => {
   //       state[key] = val;
   //    });
   }
};

export default {
   state: { ...DEFAULT_STATE },
   getters,
   actions,
   mutations
};
